exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".my-purchases-template[data-v-113e0f08]{min-height:100px;margin-top:-35px}", ""]);

